import { render, staticRenderFns } from "./RelationChart.vue?vue&type=template&id=e5c00d94&scoped=true"
import script from "./RelationChart.vue?vue&type=script&lang=js"
export * from "./RelationChart.vue?vue&type=script&lang=js"
import style0 from "./RelationChart.vue?vue&type=style&index=0&id=e5c00d94&prod&lang=scss&scoped=true"
import style1 from "./RelationChart.vue?vue&type=style&index=1&id=e5c00d94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c00d94",
  null
  
)

export default component.exports